/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Resources_Read_ArticleInputs */

const en_localcms_resources_read_article = /** @type {(inputs: Localcms_Resources_Read_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read article`)
};

/**
* | output |
* | --- |
* | "Read article" |
*
* @param {Localcms_Resources_Read_ArticleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_resources_read_article = /** @type {((inputs?: Localcms_Resources_Read_ArticleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Resources_Read_ArticleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_resources_read_article(inputs)
});